<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app floating>
      <v-list shaped dense>
        <template v-for="item in items">
          <v-list-item @click="handleNavigation" :key="item.text" v-model="active" color="primary">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text v-if="contacts"></v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app flat>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Contact urgence</span>
      </v-toolbar-title>
      <v-text-field
        flat
        solo
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Rechercher"
        background-color="grey lighten-3"
        v-model="searchValue"
      ></v-text-field>
      <v-spacer></v-spacer>
      <profile-menu :keycloak="keycloak" :currentUser="currentUser"></profile-menu>
    </v-app-bar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout row>
          <v-flex xs12>
            <v-list nav>
              <v-list-item-group color="primary">
                <template v-for="(contact, i) in contacts">
                  <v-list-item :key="i" @click="handleChange(contact._id)">
                    <v-list-item-icon>
                      <v-avatar color="grey" size="36">
                        <span class="white--text">{{contact.firstName.charAt(0)}}</span>
                      </v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{contact.firstName}} {{contact.lastName}}</v-list-item-title>
                      <v-list-item-subtitle>{{contact.program}} - {{contact.studyType}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
                  <div slot="no-more"></div>
                  <div slot="no-results">Pas de résultats</div>
                </infinite-loading>
              </v-list-item-group>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <user-dialog
      v-if="user"
      :open="userDialog"
      :toggleDialog="toggleUserDialog"
      :toggleWarningDialog="toggleWarningDialog"
      :user="user"
      :currentUser="currentUser"
    />
  </v-app>
</template>

<script>
import axios from "axios";
import ProfileMenu from "@/components/ProfileMenu";
import UserDialog from "@/components/UserDialog";
import InfiniteLoading from "vue-infinite-loading";
import { debounce } from "lodash";

export default {
  components: {
    UserDialog,
    ProfileMenu,
    InfiniteLoading
  },
  props: ["keycloak"],
  async mounted() {
    this.currentUser = await this.keycloak.loadUserInfo();
  },
  data: () => ({
    dialog: false,
    drawer: null,
    active: 1,
    items: [{ icon: "mdi-contact-phone", text: "Contacts" }],
    contacts: [],
    filteredContacts: [],
    contactModal: false,
    selectedContact: null,
    user: null,
    userDialog: false,
    currentUser: undefined,
    searchValue: "",
    page: 1,
    infiniteId: +new Date()
  }),
  watch: {
    searchValue: debounce(function() {
      this.page = 1;
      this.contacts = [];
      this.infiniteId += 1;
    }, 500)
  },
  methods: {
    infiniteHandler: function($state) {
      axios
        .get(`${process.env.VUE_APP_API_URI}/collaborator/users`, {
          params: {
            page: this.page,
            search: this.searchValue
          }
        })
        .then(({ data }) => {
          if (data.length) {
            this.page += 1;
            this.contacts.push(...data);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },
    handleNavigation: function() {
      return;
    },
    handleChange: async function(selected) {
      const { data: user } = await axios.get(
        `${process.env.VUE_APP_API_URI}/collaborator/users/${selected}`
      );
      this.selectedContact = null;
      this.user = user;
      this.userDialog = true;
    },
    toggleUserDialog: function() {
      this.userDialog = !this.userDialog;
    },
    toggleWarningDialog: function() {
      this.warningDialog = !this.warningDialog;
    }
  }
};
</script>

<style>
#inspire {
  background: white;
}
</style>
